import WorkStatus from '@/dossier/constants/WorkStatus';
import { DossierId } from '@/dossier/models/AbstractDossier';
import Identity from '@/general/models/Identity';
import MediaFile from '@/general/models/MediaFile';
import MediaTarget from '@/general/models/MediaTarget';
import { JobId } from '@/jobs/models/AbstractJob';
import Job from '@/jobs/models/Job';
import JobContext from '@/jobs/models/JobContext';
import Diagnostic from '@/jobs/models/diagnosis/Diagnostic';
import { TirePositionId } from '@/tires/models/TirePosition';
import WorkPreparationStatus from '@/workPreparation/constants/WorkPreparationStatus';
import EventBus, { BaseEvent } from '../../utils/EventBus';
import MediaTargetData from '@/general/models/MediaTargetData';

export default new EventBus();

export class UserLoggedIn extends BaseEvent {
  constructor(
    readonly user: Identity,
  ) {
    super();
  }
}

export class UserLoggedOut extends BaseEvent {
}

export class JobUpdated extends BaseEvent {
  constructor(
    readonly dossierId: DossierId,
    readonly jobId: JobId,
  ) {
    super();
  }
}

export class JobStatusUpdated extends BaseEvent {
  constructor(
    readonly dossierId: DossierId,
    readonly job: Job,
  ) {
    super();
  }
}

export class JobRemoved extends BaseEvent {
  constructor(
    readonly jobId: JobId,
  ) {
    super();
  }
}

export class DmsImportFinished extends BaseEvent {
  constructor(
    readonly dossierId: DossierId,
  ) {
    super();
  }
}

export class DossierWorkStatusChanged extends BaseEvent {
  constructor(
    readonly workStatus: WorkStatus,
    readonly dossierId: DossierId,
    readonly jobs?: Array<Job>,
  ) {
    super();
  }
}

export class WorkPreparationStatusChanged extends BaseEvent {
  constructor(
    readonly dossierId: DossierId,
    readonly status: WorkPreparationStatus,
  ) {
    super();
  }
}

export class JobTagsUpdated extends BaseEvent {
  constructor(
    readonly job: Job,
  ) {
    super();
  }
}

export class MediaUpdated extends BaseEvent {
  constructor(
    readonly mediaCount: number,
    readonly targetData: MediaTargetData,
  ) {
    super();
  }
}

export class MediaUploaded extends BaseEvent {
  constructor(
    readonly mediaFile: MediaFile,
    readonly target: MediaTarget,
  ) {
    super();
  }
}

export class MediaRemoved extends BaseEvent {
  constructor(
    readonly mediaFile: MediaFile,
    readonly target: MediaTarget,
  ) {
    super();
  }
}

abstract class DiagnosticEvent extends BaseEvent {
  constructor(
    readonly diagnostic: Diagnostic,
    readonly job: Job,
    readonly context: JobContext,
  ) {
    super();
  }
}

export class DiagnosticUpdated extends DiagnosticEvent {
}

export class DiagnosticCreated extends DiagnosticEvent {
}

export class DiagnosticRemoved extends DiagnosticEvent {
}

export class TireReplaced extends BaseEvent {
  constructor(
    readonly positionIds: Array<TirePositionId>,
    readonly isMounted: boolean,
  ) {
    super();
  }
}

export class TireDeleted extends BaseEvent {
  constructor(
    readonly positionId: TirePositionId,
    readonly isMounted: boolean,
  ) {
    super();
  }
}

export class TiresSwapped extends BaseEvent {
  constructor() {
    super();
  }
}

export class DriveBookingCheckInDangerAlert extends BaseEvent {
  constructor() {
    super();
  }
}

export class DriveBookingCheckOutOnCheckInPage extends BaseEvent {
  constructor() {
    super();
  }
}